import { cn } from "@/lib/utils";
import { CheckCircle } from "lucide-react";
import React from "react";

export const FigmaBlock = React.memo(() => {
  return (
    <div className={cn("flex flex-col grow bg-secondary-200 px-1 rounded-md")}>
      <div className="flex flex-col">
        <div className="flex flex-row items-center justify-start p-2">
          <div>
            <img
              src="/icons/ai-chat-status/success.svg"
              className="size-4 shrink-0"
            />
          </div>

          <div
            className={cn(
              "text-secondary-n-50 font-medium rounded-md text-xs py-0.5 px-2 bg-secondary-n-950 break-all",
            )}
          >
            Figma Import
          </div>
        </div>
      </div>
    </div>
  );
});
